var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-card",
    { staticClass: "auth-card" },
    [
      _c("q-card-main", [
        _c("h1", { staticClass: "text-center auth-card__heading" }, [
          _vm._v(_vm._s(_vm.$t("register_heading")))
        ]),
        _c("p", { staticClass: "text-center auth-card__description" }, [
          _vm._v(_vm._s(_vm.$t("register_description")))
        ]),
        _c(
          "form",
          {
            attrs: { id: "register-form" },
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.handleRegister($event)
              }
            }
          },
          [
            _c("div", { staticClass: "row gutter-sm" }, [
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-6" },
                [
                  _c(
                    "q-field",
                    {
                      attrs: {
                        error: _vm.errors.has("firstName"),
                        "error-label": _vm.errors.first("firstName")
                      }
                    },
                    [
                      _c("q-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate.disable",
                            value: "required|min:1|max:255",
                            expression: "'required|min:1|max:255'",
                            modifiers: { disable: true }
                          }
                        ],
                        attrs: {
                          name: "firstName",
                          "float-label": _vm.$t("first_name"),
                          required: "",
                          autofocus: ""
                        },
                        model: {
                          value: _vm.firstName,
                          callback: function($$v) {
                            _vm.firstName = $$v
                          },
                          expression: "firstName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-6" },
                [
                  _c(
                    "q-field",
                    {
                      attrs: {
                        error: _vm.errors.has("lastName"),
                        "error-label": _vm.errors.first("lastName")
                      }
                    },
                    [
                      _c("q-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate.disable",
                            value: "required|min:1|max:255",
                            expression: "'required|min:1|max:255'",
                            modifiers: { disable: true }
                          }
                        ],
                        attrs: {
                          name: "lastName",
                          "float-label": _vm.$t("last_name"),
                          required: ""
                        },
                        model: {
                          value: _vm.lastName,
                          callback: function($$v) {
                            _vm.lastName = $$v
                          },
                          expression: "lastName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c(
                    "q-field",
                    {
                      attrs: {
                        error: _vm.errors.has("email"),
                        "error-label": _vm.errors.first("email")
                      }
                    },
                    [
                      _c("q-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate.disable",
                            value: "required|email|max:255",
                            expression: "'required|email|max:255'",
                            modifiers: { disable: true }
                          }
                        ],
                        attrs: {
                          name: "email",
                          type: "email",
                          "float-label": _vm.$t("email"),
                          required: ""
                        },
                        model: {
                          value: _vm.email,
                          callback: function($$v) {
                            _vm.email = $$v
                          },
                          expression: "email"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c(
                    "q-field",
                    {
                      attrs: {
                        error: _vm.errors.has("password"),
                        "error-label": _vm.errors.first("password")
                      }
                    },
                    [
                      _c("q-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate.disable",
                            value: "required|min:8",
                            expression: "'required|min:8'",
                            modifiers: { disable: true }
                          }
                        ],
                        attrs: {
                          name: "password",
                          type: "password",
                          "float-label": _vm.$t("password"),
                          required: ""
                        },
                        model: {
                          value: _vm.password,
                          callback: function($$v) {
                            _vm.password = $$v
                          },
                          expression: "password"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c(
                    "q-field",
                    [
                      _c(
                        "q-checkbox",
                        {
                          attrs: {
                            name: "newsletter",
                            "false-value": null,
                            "indeterminate-value": false
                          },
                          model: {
                            value: _vm.newsletter,
                            callback: function($$v) {
                              _vm.newsletter = $$v
                            },
                            expression: "newsletter"
                          }
                        },
                        [
                          _c("div", { staticClass: "on-right" }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("singup_newsletter_text")) +
                                "\n              "
                            )
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "q-field",
                    {
                      attrs: {
                        error: _vm.errors.has("tos"),
                        "error-label": _vm.errors.first("tos")
                      }
                    },
                    [
                      _c(
                        "q-checkbox",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate.disable",
                              value: "required",
                              expression: "'required'",
                              modifiers: { disable: true }
                            }
                          ],
                          attrs: {
                            name: "tos",
                            "false-value": null,
                            "indeterminate-value": false,
                            "data-vv-as": _vm.$t("tos_privacy")
                          },
                          model: {
                            value: _vm.tos,
                            callback: function($$v) {
                              _vm.tos = $$v
                            },
                            expression: "tos"
                          }
                        },
                        [
                          _c(
                            "i18n",
                            {
                              staticClass: "on-right cursor-default",
                              attrs: { tag: "div", path: "tos_acceptance" }
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "primary-link",
                                  attrs: { place: "tos", href: "#" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.handleTosClick($event)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.$t("tos")) +
                                      "\n                "
                                  )
                                ]
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "primary-link",
                                  attrs: { place: "privacyPolicy", href: "#" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.handlePrivacyPolicyClick(
                                        $event
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.$t("privacy_policy")) +
                                      "\n                "
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _c(
              "div",
              { staticClass: "auth-card__footer row justify-between" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-md-auto col-xs-12 self-center auth-card__secondary-action"
                  },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "router-link",
                        attrs: { to: { name: "login" } }
                      },
                      [_vm._v(_vm._s(_vm.$t("goto_login")))]
                    )
                  ],
                  1
                ),
                !_vm.created
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "col-md-auto col-xs-12 self-center auth-card__primary-action"
                      },
                      [
                        _c(
                          "q-btn",
                          { attrs: { type: "submit", color: "primary" } },
                          [_vm._v(_vm._s(_vm.$t("register")) + "\n          ")]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }